const round_number = process.env.appraisal_methods && process.env.appraisal_methods.round_number ? 
process.env.appraisal_methods.round_number : 'NORMAL';
const standard = process.env.appraisal_methods && process.env.appraisal_methods.standard ? 
process.env.appraisal_methods.standard : ['bddc', 'tgtdcg', 'mgcd'];
const map_location = process.env.map_location ? process.env.map_location : [10.851987987311087, 106.74837598976731];
export { round_number, standard, map_location };